// Module
var code = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"58.5px\" height=\"58.5px\" viewBox=\"0 0 58.5 58.5\" style=\"enable-background:new 0 0 58.5 58.5\" xml:space=\"preserve\"> <path class=\"st0\" d=\"M55.8,26.6H31.9V2.7c0-1.5-1.2-2.7-2.7-2.7s-2.7,1.2-2.7,2.7v23.9H2.7c-1.5,0-2.7,1.2-2.7,2.7s1.2,2.7,2.7,2.7\r\n\th23.9v23.9c0,1.5,1.2,2.7,2.7,2.7s2.7-1.2,2.7-2.7V31.9h23.9c1.5,0,2.7-1.2,2.7-2.7S57.3,26.6,55.8,26.6z\"/> </svg>";
// Exports
module.exports = code;


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader/dist/cjs.js!./src/assets/icons/icon-increase.svg
// module id = 3bkq
// module chunks = 34